import { FC } from "react";

interface BigLeftArrowProps {
  disabled?: boolean;
}

const BigLeftArrow: FC<BigLeftArrowProps> = ({ disabled = false }) => {
  return (
    <>
      <svg
        className="desktop-w-25px"
        width="35"
        height="36"
        viewBox="0 0 35 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? "not-allowed" : "pointer" }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0095 8.21864C14.579 8.78815 14.579 9.71151 14.0095 10.281L7.74906 16.5415H30.4783C31.2838 16.5415 31.9367 17.1944 31.9367 17.9998C31.9367 18.8053 31.2838 19.4582 30.4783 19.4582H7.74906L14.0095 25.7186C14.579 26.2882 14.579 27.2115 14.0095 27.781C13.4399 28.3506 12.5166 28.3505 11.9471 27.781L3.19715 19.031C2.62764 18.4615 2.62764 17.5382 3.19715 16.9686L11.9471 8.21864C12.5166 7.64913 13.4399 7.64912 14.0095 8.21864Z"
          fill={disabled ? "#BDBDBD" : "black"}
        />
      </svg>
    </>
  );
};

export default BigLeftArrow;